import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom'
import Headroom from 'react-headroom'

class Header extends Component {
    state = {
        isTrans: true
    }

    componentDidMount() {
        this.checkIsTrans(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname.indexOf('/pocetna') === -1) {
            this.checkIsTrans(nextProps)
        }
    }

    onUnpinHandler = () => {
        if (this.state.isTrans) {
            this.toggleTrans(false)
        }
    }

    onUnFixHandler = () => {
        this.checkIsTrans(this.props)
    }

    toggleTrans = (isTrans) => {
        this.setState({
            isTrans
        })
    }

    checkIsTrans = (props) => {
        const path = props.location.pathname ? props.location.pathname : props.match.path
        if (path === '/' || path === '/onama') {
            this.toggleTrans(true)
        } else {
            this.toggleTrans(false)
        }
    }

    render() {
        let activeLangClassHr = 'header-lang-picker--active'
        let activeLangClassEn = ''
        let transClass = ''
        if (this.state.isTrans) {
            transClass = 'header-container--trans'
        }
        if (this.props.activeLang === 'en') {
            activeLangClassHr = ''
            activeLangClassEn = 'header-lang-picker--active'
        }

        const itemsData = this.props.langData.header
        const headerItems = itemsData.map((val, key) => (
            <NavLink
                to={val.path}
                className="header-item"
                activeClassName="header-item--active"
                key={key}
                exact={val.exact}
            >
                <span className="header-item__text">{val.title}</span>
            </NavLink>
        ))

        return (
            <Headroom
                disableInlineStyles
                onUnpin={this.onUnpinHandler}
                onUnfix={this.onUnFixHandler}
            >
                <div className={`header-container ${transClass}`}>
                    <div className="header-inner">
                        <img className="header-logo" src="/images/ico/bed_logo.png" />
                        <div className="header-items-container header-menu-text">
                            {headerItems}
                        </div>
                        <div className="header-info-container header-info-text">
                            <div className="header-lang-picker">
                                <a href={`${this.props.location.pathname}`} hrefLang="hr">
                                    <span className={`header-lang-picker__text ${activeLangClassHr}`}>HR</span>
                                </a>
                                <div className="header-lang-picker__dash"></div>
                                <a href={`/en${this.props.location.pathname}`} hrefLang="en">
                                    <span className={`header-lang-picker__text ${activeLangClassEn}`}>EN</span>
                                </a>
                            </div>
                            <div className="phone">
                                <img className="phone-img" src="/images/ico/bed_phone.png" />
                                <span className="phone-text">098 912 4789</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Headroom>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData,
    activeLang: state.activeLang
})

export default withRouter(connect(mapStateToProps)(Header))



// WEBPACK FOOTER //
// ./src/scripts/components/Header.jsx